import { MessageRole } from '../assistant';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_MESSAGE_ROLE = 'MESSAGE_ROLE_';

export const MessageRoleTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_MESSAGE_ROLE}${MessageRole.USER}`]: 'Utilisateur',
    [`${TRANSLATE_KEY_MESSAGE_ROLE}${MessageRole.ASSISTANT}`]: 'Pulse',
    [`${TRANSLATE_KEY_MESSAGE_ROLE}${MessageRole.SYSTEM}`]: 'Système',
    [`${TRANSLATE_KEY_MESSAGE_ROLE}${MessageRole.TOOL}`]: 'Outil',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(MessageRole, MessageRoleTranslation, TRANSLATE_KEY_MESSAGE_ROLE, true);
